<script>
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  props: {
    templateName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      provinceOfficeLevel: -1, // 省级分公司层级
      opOfficeDisabled: false
    }
  },
  computed: {
    // 是否可以进行区域内委托
    isRegionalCommission() {
      return this.provinceOfficeLevel >= 0 && this.$store.getters.currentOfficeLevel >= this.provinceOfficeLevel && this.$checkPermission(['roleGroup_Common_regionalCommission'])
    },
    // 销售分公司
    salesOffice() {
      // 需覆盖这个属性
      return 0
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.provinceOfficeLevel = Number(cache.config.get('RegionalCommission'))
        this.salesCurrentOfficeChange()
      }
    },
    salesOffice() {
      this.salesCurrentOfficeChange()
    }
  },
  methods: {
    // 销售公司或当前分公司改变
    async salesCurrentOfficeChange() {
      this.opOfficeDisabled = false
      if (this.salesOffice === this.$store.getters.currentOfficeId) {
        await cache.load(cacheName.CONFIG)
        if (cache.config.get('ToExoSystem') === 'zy') {
          if (!this.$checkPermission(['roleGroup_Common_regionalCommission'])) {
            this.setOpOffice(this.$store.getters.currentOfficeId)
            this.opOfficeDisabled = true
          }
        }
      }
    },
    // 设置操作分公司
    setOpOffice(val) {
      // 需覆盖这个方法
    }
  }
}
</script>
